/* TP 2026-10 — "För dig": Rekommenderat för dig + Senast visade.

   Hör till sections/tp-personal.liquid. Filen gör tre saker:

     1. Minns vad kunden tittar på. Varje produktsida läggs först i en
        lista (högst 20). Samtidigt räknas ett intresse upp för produktens
        märke, typ och närmaste kategorier. Kategorisidor och filter på
        Märke räknas lite, köp (tp:cart:added) räknas mest. Gamla intressen
        bleknar för varje ny produkt, så det kunden tittar på NU väger
        tyngst.
     2. Ritar "Senast visade": de senast visade produkterna, nyast först,
        utan den kunden står på. Korten hämtas från produktens egen vy
        (/products/<handle>?view=tp-card).
     3. Ritar "Rekommenderat för dig": Shopifys rekommendationer för de tre
        senast visade produkterna, sorterade efter kundens intresse. Det
        kunden redan sett eller har i korgen plockas bort. Blir raden kort
        fylls den på ur kategorin kunden visat mest intresse för.

   Integritet: allt ligger i kundens egen webbläsare (localStorage,
   tp_personal_v1) och skrivs bara när kunden godkänt "Preferenser" i
   cookiebannern (tp_cookie_consent_v3 / Shopifys customerPrivacy). Utan
   samtycke ritas och sparas ingenting, och drar kunden tillbaka det
   raderas historiken. Inget skickas någonstans.

   Raden är startsidans produktrad (section-tp2-home.css) och dras, pilas
   och swajpas av radmotorn (tp-drag-scroll.js), som kopplar in raden när
   den läggs i sidan. Köp går via kortets formulär till TPCart; den här
   filen lyssnar bara på tp:cart:added och rör aldrig korgen. */
(function () {
  'use strict';

  if (window.TPPersonal) {
    window.TPPersonal.scan();
    return;
  }

  var KEY = 'tp_personal_v1';
  var CONSENT_KEY = 'tp_cookie_consent_v3';
  var CARD_CACHE = 'tp_personal_cards_v1';
  var CARD_TTL = 10 * 60 * 1000;
  var MAX_RECENT = 20;
  var MAX_KEYS = 80;
  var FADE = 0.92;
  var MIN_RECS = 4;

  var allowed = null;

  /* ---- Samtycke -------------------------------------------------- */

  function localConsent() {
    try {
      var saved = JSON.parse(localStorage.getItem(CONSENT_KEY) || 'null');
      if (saved && typeof saved.preferences === 'boolean') return saved.preferences;
    } catch (error) {}
    return null;
  }

  function apiConsent() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.preferencesProcessingAllowed === 'function') {
        return Boolean(api.preferencesProcessingAllowed());
      }
    } catch (error) {}
    return null;
  }

  /* Cookiebannern sparar kundens val lokalt. Finns inget sparat val
     frågar vi Shopify, vars samtyckes-API laddas av bannern en stund
     efter sidladdningen. Svarar ingen räknas det som nej för stunden —
     utan att något raderas. */
  function whenConsentKnown(callback) {
    var local = localConsent();
    if (local !== null) {
      callback(local);
      return;
    }
    var tries = 0;
    (function poll() {
      var api = apiConsent();
      if (api !== null) {
        callback(api);
        return;
      }
      tries += 1;
      if (tries > 40) {
        callback(null);
        return;
      }
      window.setTimeout(poll, 250);
    })();
  }

  /* ---- Lagring --------------------------------------------------- */

  function blank() {
    return { v: 1, r: [], a: {} };
  }

  function read() {
    try {
      var state = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (state && state.v === 1 && Array.isArray(state.r) && state.a && typeof state.a === 'object') {
        return state;
      }
    } catch (error) {}
    return blank();
  }

  function write(state) {
    Object.keys(state.a).forEach(function (key) {
      state.a[key] = Math.round(state.a[key] * 1000) / 1000;
    });
    try {
      localStorage.setItem(KEY, JSON.stringify(state));
    } catch (error) {
      /* Privat läge eller full lagring: då blir det ingen historik. */
    }
  }

  function wipe() {
    try { localStorage.removeItem(KEY); } catch (error) {}
    try { sessionStorage.removeItem(CARD_CACHE); } catch (error) {}
  }

  /* ---- Intresse -------------------------------------------------- */

  function norm(value) {
    return String(value || '').toLowerCase().trim();
  }

  function bump(state, key, weight) {
    if (!key || key.length < 3) return;
    state.a[key] = (state.a[key] || 0) + weight;
  }

  function fade(state) {
    Object.keys(state.a).forEach(function (key) {
      state.a[key] = state.a[key] * FADE;
      if (state.a[key] < 0.05) delete state.a[key];
    });
    var keys = Object.keys(state.a);
    if (keys.length <= MAX_KEYS) return;
    keys.sort(function (x, y) { return state.a[y] - state.a[x]; });
    keys.slice(MAX_KEYS).forEach(function (key) { delete state.a[key]; });
  }

  function bumpProduct(state, item, weight) {
    if (item.b) bump(state, 'b:' + item.b, weight);
    if (item.t) bump(state, 't:' + item.t, weight);
    (item.c || []).forEach(function (handle, index) {
      bump(state, 'c:' + handle, index === 0 ? weight : weight * 0.6);
    });
  }

  function context() {
    var el = document.querySelector('[data-tp-personal-ctx]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (error) {
      return {};
    }
  }

  function track(ctx) {
    var state = read();

    if (ctx.page === 'product' && ctx.h) {
      fade(state);
      var entry = {
        h: ctx.h,
        id: ctx.id,
        b: norm(ctx.b),
        t: norm(ctx.t),
        c: (ctx.c || []).slice(0, 5)
      };
      state.r = [entry]
        .concat(state.r.filter(function (item) { return item && item.h && item.h !== ctx.h; }))
        .slice(0, MAX_RECENT);
      bumpProduct(state, entry, 1);
      write(state);
      return;
    }

    if (ctx.page === 'collection' && ctx.h) {
      bump(state, 'c:' + ctx.h, 0.5);
      try {
        var params = new URLSearchParams(window.location.search);
        params.getAll('filter.p.m.custom.brand').forEach(function (value) {
          bump(state, 'b:' + norm(value), 0.75);
        });
        params.getAll('filter.p.product_type').forEach(function (value) {
          bump(state, 't:' + norm(value), 0.75);
        });
      } catch (error) {}
      write(state);
    }
  }

  /* Det kunden lägger i korgen är den starkaste signalen. */
  document.addEventListener('tp:cart:added', function (event) {
    if (allowed !== true) return;
    var items = (event.detail && event.detail.items) || [];
    if (!items.length) return;
    var state = read();
    items.forEach(function (item) {
      var known = null;
      for (var i = 0; i < state.r.length; i++) {
        if (state.r[i].h === item.handle) {
          known = state.r[i];
          break;
        }
      }
      if (known) {
        bumpProduct(state, known, 1.5);
        return;
      }
      /* Köpt direkt från en rekommendation: kortets egna uppgifter om
         märke, typ och kategorier finns på raden. */
      var handle = window.CSS && CSS.escape ? CSS.escape(item.handle || '') : item.handle;
      var card = handle ? document.querySelector('[data-tp-p-h="' + handle + '"][data-tp-p-b]') : null;
      if (card) {
        bumpProduct(state, {
          b: card.getAttribute('data-tp-p-b'),
          t: card.getAttribute('data-tp-p-t'),
          c: (card.getAttribute('data-tp-p-c') || '').split('|').filter(Boolean)
        }, 1.5);
      } else if (item.product_type) {
        bump(state, 't:' + norm(item.product_type), 1);
      }
    });
    write(state);
  });

  /* ---- Hämtning -------------------------------------------------- */

  function fetchText(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (response.status === 404) return { gone: true, html: '' };
        return response.ok ? response.text().then(function (html) { return { html: html }; }) : { html: '' };
      })
      .catch(function () { return { html: '' }; });
  }

  function readCache() {
    try {
      var cache = JSON.parse(sessionStorage.getItem(CARD_CACHE) || '{}');
      return cache && typeof cache === 'object' ? cache : {};
    } catch (error) {
      return {};
    }
  }

  function writeCache(cache) {
    try {
      sessionStorage.setItem(CARD_CACHE, JSON.stringify(cache));
    } catch (error) {
      try { sessionStorage.removeItem(CARD_CACHE); } catch (ignore) {}
    }
  }

  function parse(html, selector) {
    var holder = document.createElement('div');
    holder.innerHTML = html;
    return Array.prototype.slice.call(holder.querySelectorAll(selector));
  }

  /* Ett kort ur svarsmallen (.as-related-card) blir en rad-plats i
     produktraden. */
  function toItem(wrapper) {
    var li = document.createElement('li');
    li.className = 'tp2-row__item';
    li.setAttribute('data-tp-p-h', wrapper.getAttribute('data-related-handle') || '');
    while (wrapper.firstChild) li.appendChild(wrapper.firstChild);
    return li;
  }

  function cartHandles(root) {
    var stateCart = window.TPCart && typeof window.TPCart.getState === 'function' ? window.TPCart.getState() : null;
    var ready = stateCart
      ? Promise.resolve(stateCart)
      : fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (response) { return response.ok ? response.json() : null; })
          .catch(function () { return null; });
    return ready.then(function (cart) {
      return ((cart && cart.items) || []).map(function (item) { return item.handle; });
    });
  }

  function loadRecent(root, list) {
    var cache = readCache();
    var now = Date.now();
    var gone = [];

    return Promise.all(list.map(function (item) {
      var hit = cache[item.h];
      if (hit && now - hit.at < CARD_TTL) return Promise.resolve(hit.html);
      return fetchText(root + 'products/' + encodeURIComponent(item.h) + '?view=tp-card').then(function (res) {
        if (res.gone) gone.push(item.h);
        cache[item.h] = { at: now, html: res.html };
        return res.html;
      });
    })).then(function (htmls) {
      writeCache(cache);

      /* Produkter som inte längre finns tas bort ur historiken. */
      if (gone.length) {
        var state = read();
        state.r = state.r.filter(function (item) { return gone.indexOf(item.h) === -1; });
        write(state);
      }

      var items = [];
      htmls.forEach(function (html) {
        if (!html) return;
        var card = parse(html, '[data-related-handle]')[0];
        if (card) items.push(toItem(card));
      });
      return items;
    });
  }

  function score(state, li) {
    var total = 0;
    var brand = li.getAttribute('data-tp-p-b');
    var type = li.getAttribute('data-tp-p-t');
    if (brand) total += state.a['b:' + brand] || 0;
    if (type) total += state.a['t:' + type] || 0;
    (li.getAttribute('data-tp-p-c') || '').split('|').forEach(function (handle) {
      if (handle) total += (state.a['c:' + handle] || 0) * 0.5;
    });
    return total;
  }

  function topCollection(state, skip) {
    var best = '';
    var bestScore = 0;
    Object.keys(state.a).forEach(function (key) {
      if (key.indexOf('c:') !== 0 || key === 'c:' + skip) return;
      if (state.a[key] > bestScore) {
        best = key.slice(2);
        bestScore = state.a[key];
      }
    });
    return best;
  }

  function loadRecs(root, recUrl, state, recent, current, here, max) {
    var seeds = recent.filter(function (item) { return item.id; }).slice(0, 3);
    if (!seeds.length) return Promise.resolve([]);

    return cartHandles(root).then(function (inCart) {
      var seen = {};
      recent.forEach(function (item) { seen[item.h] = true; });
      inCart.forEach(function (handle) { seen[handle] = true; });
      if (current) seen[current] = true;

      return Promise.all(seeds.map(function (seed) {
        return fetchText(recUrl + '?product_id=' + encodeURIComponent(seed.id) + '&limit=10&intent=related&section_id=tp-personal');
      })).then(function (responses) {
        var scored = [];
        responses.forEach(function (res, seedIndex) {
          parse(res.html, 'li[data-tp-p-h]').forEach(function (li, position) {
            var handle = li.getAttribute('data-tp-p-h');
            if (!handle || seen[handle]) return;
            seen[handle] = true;
            /* Kundens intresse styr; Shopifys egen ordning och vilken
               produkt förslaget kom ifrån avgör när intresset är lika. */
            var base = (1 - position / 10) * (1 - seedIndex * 0.2);
            scored.push({ li: li, score: score(state, li) + base, order: scored.length });
          });
        });

        /* Varierad rad: samma märke får en liten avräkning för varje kort
           det redan har i raden. Annars blev det lätt sex storlekar av
           samma puck i följd. */
        var items = [];
        var perBrand = {};
        while (items.length < max && scored.length) {
          var bestIndex = 0;
          var bestValue = -Infinity;
          for (var i = 0; i < scored.length; i++) {
            var brand = scored[i].li.getAttribute('data-tp-p-b') || '';
            var value = scored[i].score - 0.6 * (perBrand[brand] || 0) - scored[i].order * 0.0001;
            if (value > bestValue) {
              bestValue = value;
              bestIndex = i;
            }
          }
          var pick = scored.splice(bestIndex, 1)[0];
          var pickBrand = pick.li.getAttribute('data-tp-p-b') || '';
          perBrand[pickBrand] = (perBrand[pickBrand] || 0) + 1;
          items.push(pick.li);
        }
        if (items.length >= Math.min(max, MIN_RECS * 2)) return items;

        /* Nya produkter har ännu inga rekommendationer. Då fylls raden
           på ur kategorin kunden visat mest intresse för — aldrig den
           kategori kunden redan står i. */
        var fill = topCollection(state, here);
        if (!fill) return items;
        return fetchText(root + 'collections/' + encodeURIComponent(fill) + '?view=tp-rail').then(function (res) {
          parse(res.html, '[data-related-handle]').forEach(function (card) {
            if (items.length >= max) return;
            var handle = card.getAttribute('data-related-handle');
            if (!handle || seen[handle]) return;
            seen[handle] = true;
            items.push(toItem(card));
          });
          return items;
        });
      });
    });
  }

  /* ---- Stilar ---------------------------------------------------- */

  /* Raden och korten har sina stilar i egna filer. Startsidan,
     kollektionen och produktsidan har dem redan; på övriga sidor läggs de
     till här, först när det finns något att visa. */
  function ensureCss(root) {
    var urls = (root.getAttribute('data-css') || '').split(' ').filter(Boolean);
    var links = Array.prototype.slice.call(document.querySelectorAll('link[href]'));

    return Promise.all(urls.map(function (url) {
      var path = new URL(url, window.location.href).pathname;
      var link = null;
      for (var i = 0; i < links.length; i++) {
        if (new URL(links[i].href, window.location.href).pathname === path) {
          link = links[i];
          break;
        }
      }
      if (link && link.sheet) return true;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        document.head.appendChild(link);
      }
      return new Promise(function (resolve) {
        link.addEventListener('load', resolve, { once: true });
        link.addEventListener('error', resolve, { once: true });
        window.setTimeout(resolve, 3000);
      });
    }));
  }

  /* ---- Raderna --------------------------------------------------- */

  function addRow(root, kind, items) {
    var template = root.querySelector('template[data-tp-personal-row="' + kind + '"]');
    if (!template || !items.length) return;
    var row = template.content.querySelector('[data-tp-personal-kind]').cloneNode(true);
    var track = row.querySelector('[data-tp-personal-track]');
    items.forEach(function (li) { track.appendChild(li); });
    track.style.setProperty('--tp2-peek', items.length > 4 ? '0.25' : '0');
    root.insertBefore(row, root.querySelector('[data-tp-personal-status]'));
    if (window.tp2SyncFavoriteButtons) window.tp2SyncFavoriteButtons(row);
  }

  function clearRows(root) {
    Array.prototype.slice.call(root.querySelectorAll('[data-tp-personal-kind]')).forEach(function (row) {
      row.remove();
    });
  }

  function whenNear(root, callback) {
    if (!('IntersectionObserver' in window)) {
      callback();
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      callback();
    }, { rootMargin: '800px 0px' });
    observer.observe(root);
  }

  function mount(root) {
    if (root.hasAttribute('data-tp-personal-ready')) return;
    root.setAttribute('data-tp-personal-ready', '');

    var state = read();
    var ctx = context();
    var current = ctx.page === 'product' ? ctx.h || '' : '';
    var here = ctx.page === 'collection' ? ctx.h || '' : '';
    var recent = state.r.filter(function (item) { return item && item.h && item.h !== current; });
    if (!recent.length) return;

    var max = parseInt(root.getAttribute('data-max'), 10) || 12;
    var base = root.getAttribute('data-root') || '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    var recUrl = root.getAttribute('data-rec-url') || base + 'recommendations/products';
    var wantRecs = root.getAttribute('data-recs') === 'true';

    whenNear(root, function () {
      Promise.all([
        wantRecs ? loadRecs(base, recUrl, state, recent, current, here, max) : Promise.resolve([]),
        loadRecent(base, recent.slice(0, max)),
        ensureCss(root)
      ]).then(function (results) {
        if (allowed !== true) return;
        clearRows(root);
        if (results[0].length >= MIN_RECS) addRow(root, 'recs', results[0]);
        addRow(root, 'recent', results[1]);
      });
    });
  }

  function scan() {
    if (allowed !== true) return;
    Array.prototype.slice.call(document.querySelectorAll('[data-tp-personal]')).forEach(mount);
  }

  function forget(message) {
    wipe();
    Array.prototype.slice.call(document.querySelectorAll('[data-tp-personal]')).forEach(function (root) {
      clearRows(root);
      root.removeAttribute('data-tp-personal-ready');
      var status = root.querySelector('[data-tp-personal-status]');
      if (status && message) status.textContent = message;
    });
  }

  /* "Rensa" tar bort hela historiken: senast visade och intressena. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-tp-personal-clear]');
    if (!button) return;
    forget('Historiken är rensad.');
  });

  /* Kunden ändrar sitt val i cookiebannern. */
  document.addEventListener('visitorConsentCollected', function (event) {
    var detail = event.detail || {};
    if (detail.preferencesAllowed === false) {
      allowed = false;
      forget('');
      return;
    }
    if (detail.preferencesAllowed === true && allowed !== true) {
      allowed = true;
      track(context());
      scan();
    }
  });

  document.addEventListener('shopify:section:load', function () {
    scan();
  });

  window.TPPersonal = {
    scan: scan,
    clear: function () { forget(''); }
  };

  function start() {
    whenConsentKnown(function (ok) {
      if (ok === null) return;
      if (allowed !== null) return;
      allowed = ok;
      if (!ok) {
        wipe();
        return;
      }
      track(context());
      scan();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
